import { PillStateType } from '@kubit/web-ui-components/pill/types';
import { commonStyles, labelDisabledCommonStyles, labelDisabledSelectedCommonStyles, labelSelectedCommonStyles, } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [PillStateType.DEFAULT]: {
            ...commonStyles(FOUNDATIONS, FONT),
        },
        [PillStateType.SELECTED]: {
            ...commonStyles(FOUNDATIONS, FONT),
            label: {
                ...labelSelectedCommonStyles(FOUNDATIONS, FONT),
            },
        },
        [PillStateType.DISABLED]: {
            ...commonStyles(FOUNDATIONS, FONT),
            label: {
                ...labelDisabledCommonStyles(FOUNDATIONS, FONT),
            },
        },
        [PillStateType.DISABLED_SELECTED]: {
            ...commonStyles(FOUNDATIONS, FONT),
            label: {
                ...labelDisabledSelectedCommonStyles(FOUNDATIONS, FONT),
            },
        },
    };
};
//# sourceMappingURL=regular.js.map